import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgIconCustomChevronUp({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M1 14.5c0 .128.047.256.14.354a.457.457 0 00.67 0L10 6.207l8.192 8.647a.457.457 0 00.67 0 .52.52 0 000-.707l-8.527-9a.457.457 0 00-.67 0l-8.527 9A.513.513 0 001 14.5V14.5z"
        fill="currentColor"
        fillRule="nonzero"
        stroke="currentColor"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export default SvgIconCustomChevronUp;
